"use client";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <head>
        <title>Error</title>
      </head>
      <body
        style={{
          background: "#1b1b1b",
          color: "#f5f5f5",
          fontFamily: "system-ui, sans-serif",
          margin: 0,
        }}
      >
        <div
          role="alert"
          style={{
            display: "flex",
            minHeight: "100vh",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            padding: "1rem",
            textAlign: "center",
          }}
        >
          <h2 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
            Something went wrong
          </h2>
          <p style={{ color: "#9ca3af", maxWidth: "28rem" }}>
            A critical error occurred.
          </p>
          <button
            onClick={reset}
            style={{
              background: "#B63E96",
              color: "white",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
              border: "none",
              cursor: "pointer",
              fontSize: "0.875rem",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
